import React, { useState } from 'react';
import { Button, Progress, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { storage } from '../config/firebase';



export default function DigitalProductUploader({ 
  productId, 
  cmtId, 
  currentVersion, 
  onUploadComplete 
}) {
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!cmtId) {
      message.error('CMT ID is required for upload');
      return;
    }

    if (!productId) {
      message.error('Product ID is required for upload');
      return;
    }

    try {
      setIsUploading(true);
      setUploadProgress(0);

      // Create a unique filename with timestamp
      const timestamp = Date.now();
      const fileName = `${file.name.replace(/\.[^/.]+$/, '')}_${timestamp}${file.name.substring(file.name.lastIndexOf('.'))}`;
      
      // Create storage reference with the correct path structure
      const storagePath = `cmt_digital_products/${cmtId}/${productId}/${fileName}`;
      const storageRef = ref(storage, storagePath);
      
      console.log('Uploading to storage path:', storagePath);

      // Upload file
      const uploadTask = uploadBytesResumable(storageRef, file);

      // Monitor upload progress
      uploadTask.on('state_changed',
        (snapshot) => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log('Upload progress:', progress);
          setUploadProgress(progress);
        },
        (error) => {
          console.error('Error uploading file:', error);
          message.error('Failed to upload file. Please try again.');
          setIsUploading(false);
        },
        async () => {
          try {
            // Get download URL
            console.log('Upload completed, getting download URL');
            const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
            console.log('Download URL obtained:', downloadURL);

            // Call onUploadComplete with file details
            const fileDetails = {
              fileName: file.name,
              fileSize: file.size,
              downloadURL,
              storagePath,
              contentType: file.type
            };
            console.log('Calling onUploadComplete with details:', fileDetails);
            onUploadComplete(fileDetails);
            
            // Reset file input to allow re-uploading same filename
            const fileInput = document.getElementById('file-upload');
            if (fileInput) {
              fileInput.value = '';
            }
          } catch (error) {
            console.error('Error getting download URL:', error);
            message.error('Failed to get download URL. Please try again.');
          } finally {
            setIsUploading(false);
            setUploadProgress(0);
          }
        }
      );
    } catch (error) {
      console.error('Error in handleFileUpload:', error);
      message.error('Failed to upload file. Please try again.');
      setIsUploading(false);
      setUploadProgress(0);
    }
  };

  const handleButtonClick = () => {
    // Trigger the file input click
    document.getElementById('file-upload').click();
  };

  return (
    <div className="d-flex align-items-center">
      <input
        type="file"
        accept=".pdf"
        onChange={handleFileUpload}
        style={{ display: 'none' }}
        id="file-upload"
        disabled={isUploading}
      />
      <Button
        type="button"
        icon={<UploadOutlined />}
        loading={isUploading}
        disabled={isUploading}
        onClick={handleButtonClick}
        style={{ backgroundColor: '#39325b', color: 'white' }}
      >
        Upload Completed Version
      </Button>
      {isUploading && (
        <Progress
          percent={Math.round(uploadProgress)}
          size="small"
          style={{ marginLeft: 8, marginBottom: 0, width: 100 }}
        />
      )}
    </div>
  );
} 